module.exports = __webpack_public_path__ + "img/PL08450.eb16beea.png";